var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function AlignRight2IconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 6.00426C18 5.44962 17.5554 5 16.9991 5H3.00087C2.4481 5 2 5.45098 2 6.00426V9.99573C2 10.5504 2.44463 11 3.00087 11H16.9991C17.5519 11 18 10.549 18 9.99573V6.00426ZM16 7V9H4V7H16ZM18 14.0043C18 13.4496 17.5509 13 17.0046 13H8.9954C8.44565 13 8 13.451 8 14.0043V17.9957C8 18.5504 8.44911 19 8.9954 19H17.0046C17.5543 19 18 18.549 18 17.9957V14.0043ZM16 15V17H10V15H16ZM22 2.99865C22 2.44711 21.5561 2 21 2C20.4477 2 20 2.44577 20 2.99865V21.0014C20 21.5529 20.4439 22 21 22C21.5523 22 22 21.5542 22 21.0014V2.99865Z", fill: "" })));
}
export var AlignRight2Icon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: AlignRight2IconInner }, props))); };
//# sourceMappingURL=AlignRight2Icon.js.map